import { type CountryCode } from 'libphonenumber-js'
import { ReactNode } from 'react'
import ReactCountryFlag from 'react-country-flag'

export const countryOptions = [
  { code: 'GB', label: '+44 (GB)', value: '+44' },
  { code: 'AL', label: '+355 (AL)', value: '+355' },
  { code: 'AD', label: '+376 (AD)', value: '+376' },
  { code: 'AM', label: '+374 (AM)', value: '+374' },
  { code: 'AT', label: '+43 (AT)', value: '+43' },
  { code: 'AZ', label: '+994 (AZ)', value: '+994' },
  { code: 'BY', label: '+375 (BY)', value: '+375' },
  { code: 'BE', label: '+32 (BE)', value: '+32' },
  { code: 'BA', label: '+387 (BA)', value: '+387' },
  { code: 'BG', label: '+359 (BG)', value: '+359' },
  { code: 'HR', label: '+385 (HR)', value: '+385' },
  { code: 'CY', label: '+357 (CY)', value: '+357' },
  { code: 'CZ', label: '+420 (CZ)', value: '+420' },
  { code: 'DK', label: '+45 (DK)', value: '+45' },
  { code: 'EE', label: '+372 (EE)', value: '+372' },
  { code: 'FI', label: '+358 (FI)', value: '+358' },
  { code: 'FR', label: '+33 (FR)', value: '+33' },
  { code: 'DE', label: '+49 (DE)', value: '+49' },
  { code: 'GR', label: '+30 (GR)', value: '+30' },
  { code: 'HU', label: '+36 (HU)', value: '+36' },
  { code: 'IS', label: '+354 (IS)', value: '+354' },
  { code: 'IE', label: '+353 (IE)', value: '+353' },
  { code: 'IT', label: '+39 (IT)', value: '+39' },
  { code: 'LV', label: '+371 (LV)', value: '+371' },
  { code: 'LI', label: '+423 (LI)', value: '+423' },
  { code: 'LT', label: '+370 (LT)', value: '+370' },
  { code: 'LU', label: '+352 (LU)', value: '+352' },
  { code: 'MT', label: '+356 (MT)', value: '+356' },
  { code: 'MD', label: '+373 (MD)', value: '+373' },
  { code: 'MC', label: '+377 (MC)', value: '+377' },
  { code: 'ME', label: '+382 (ME)', value: '+382' },
  { code: 'NL', label: '+31 (NL)', value: '+31' },
  { code: 'MK', label: '+389 (MK)', value: '+389' },
  { code: 'NO', label: '+47 (NO)', value: '+47' },
  { code: 'PL', label: '+48 (PL)', value: '+48' },
  { code: 'PT', label: '+351 (PT)', value: '+351' },
  { code: 'RO', label: '+40 (RO)', value: '+40' },
  { code: 'SM', label: '+378 (SM)', value: '+378' },
  { code: 'RS', label: '+381 (RS)', value: '+381' },
  { code: 'SK', label: '+421 (SK)', value: '+421' },
  { code: 'SI', label: '+386 (SI)', value: '+386' },
  { code: 'ES', label: '+34 (ES)', value: '+34' },
  { code: 'SE', label: '+46 (SE)', value: '+46' },
  { code: 'CH', label: '+41 (CH)', value: '+41' },
  { code: 'TR', label: '+90 (TR)', value: '+90' },
  { code: 'UA', label: '+380 (UA)', value: '+380' },
] as Array<{
  code: CountryCode
  label: string
  value: string
}>

const generateLabelWithFlag = (countryCode: string, countryName: string) => (
  <div className={'flex items-center'}>
    <ReactCountryFlag countryCode={countryCode} svg />
    <p className={'mb-0 ml-2'}>{countryName}</p>
  </div>
)

export interface ICountryOptionsWithFlags {
  code: CountryCode
  label: ReactNode
  value: string
}

export const countryOptionsWithFlags = countryOptions.map(
  (option): ICountryOptionsWithFlags => ({
    ...option,
    label: generateLabelWithFlag(option.code, option.value),
  }),
)
